import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16 0v32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 32V0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M24 20.466q.948-.168 2.131-1.065a.333.333 0 1 1 .404.531q-1.364 1.04-2.535 1.21v2.525a.333.333 0 1 1-.667 0v-2.505c-.789-.072-1.636-.49-2.545-1.238a.333.333 0 1 1 .424-.515c.79.651 1.498 1.008 2.121 1.082v-4.824a.333.333 0 1 1 .667 0z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M23.667 24.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      d: "m26.206 18.197-4.816-4.378-1.085 1.085-1.886-1.886.995-.995-.039-.036a.433.433 0 0 1 .583-.641l6.849 6.226a1.667 1.667 0 1 1-.6.625"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m26.016 13.753-4.888 4.444a1.667 1.667 0 1 1-.6-.625l6.847-6.226a.433.433 0 0 1 .615.61l1.063 1.062-1.886 1.886zm-2.349-1.269c.92 0 1.666-.062 1.666-1.35 0-1.29-.746-3.134-1.666-3.134S22 9.845 22 11.133s.746 1.35 1.667 1.35",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M23.667 12.558c.736 0 1.333-.15 1.333-.333 0-.185-.597-.334-1.333-.334-.737 0-1.334.15-1.334.334s.597.333 1.334.333",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagVat = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagVat_default = SvgFlagVat;

export { FlagVat_default as default };
